export default {
  computed: {
    currentBuilding:     ({$store, currentBuildingId}) => $store.getters['area/buildingFind'](currentBuildingId),
    currentBuildingId:   ({$store}) => $store.state.current.buildingId,
    svgElm() {
      return this.$store.state.map.svgElm;
    },
    baseDomRect: ({$store}) => $store.state.map.baseDomRect,
    pxToSvgSize() {
      return (value) => {
        let ratio = 1;

        if (this.$store.state.map.getFitOrientation  == 'height') {
          ratio = this.currentBuilding.depth / this.baseDomRect.height;
        } else {
          ratio = this.currentBuilding.width / this.baseDomRect.width;
        };

        if (ratio === Infinity) ratio = 0;

        return ratio * value;
      }
    },
    isCenterSpot() {
      return (tags) => {
        return tags.some((tag) => tag.type.includes('StaticTag') && tag.name.includes('中央エリア'));
      };
    },
    isIndividualSpot() {
      return (tags) => {
        return tags.some((tag) => tag.type.includes('StaticTag') && tag.name.includes('個別スポット'));
      };
    },
    isPrivateSpot() {
      return (spot) => {
        return spot.spotState && spot.type.indexOf('PrivateSpot') >= 0;
      }
    },
  },
}



// WEBPACK FOOTER //
// ./src/mixins/map.js